export interface Collection {
  id: string;
  name: string;
  french: string;
  tagline: string;
  description: string;
  features: string[];
  priceFrom: string;
  image: string;
  provenance: string;
  lightStudy: string;
  ritual: string;
}

export const collections: Collection[] = [
  {
    id: "tsunagari",
    name: "「この人になら、紹介できる」",
    french: "",
    tagline: "そう思える相手と、出会う。",
    description:
      "交流会のあとの連絡って、正直、作業になりがちです。でも人として知り合って、信頼できたら、たとえ当人同士の事業が噛み合っていなかったとしても、自分の周りの大切な人を紹介したくなる。この会が作りたいのは、その繋がりだけです。",
    features: ["名刺交換より大切なこと", "人として先に知り合う", "月に一度、新宿にて"],
    priceFrom: "体験入部 ¥9,500",
    provenance: "月に一度、新宿のシーシャラウンジにて",
    lightStudy: "名刺を交換した人の顔を、何人思い出せますか。",
    ritual: "「この人になら大切な人を紹介できる」と思える出会いを。",
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20elegant%20drink%20glasses%20on%20a%20cobalt%20blue%20marble%20table%20surface%20in%20a%20bright%20minimalist%20lounge%2C%20soft%20natural%20daylight%2C%20light%20gray%20sofa%20blurred%20in%20the%20background%2C%20clean%20white%20interior%20walls%2C%20refreshing%20beverages%20in%20stylish%20glassware%2C%20vivid%20blue%20accent%20color%20dominating%20the%20scene%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20editorial%20product%20photography%20with%20soft%20shadows&width=1200&height=1500&seq=card-blue-01&orientation=portrait",
  },
  {
    id: "hanashi",
    name: "話せる",
    french: "はなし",
    tagline: "誰にも話せなかった話を。",
    description:
      "経営者は日頃、聞き役に回ることが多く、自分の話を安心してできる場所が意外とありません。この会には「ここで話したことは、外に持ち出さない」というルールがあります。だから、普段は口にしないプライベートの話も、まだ誰にも言っていない考えも、ここでは話せます。そしてその話は、聞いた人がへぇとひとつ持ち帰れる話であれば、愚痴でも自慢でもなく、みんなの財産になります。",
    features: ["外に持ち出さないルール", "安心して話せる場所", "愚痴でも自慢でも歓迎"],
    priceFrom: "体験入部 ¥9,500",
    provenance: "ここで話したことは、外に持ち出さない",
    lightStudy: "経営者が自分の話を安心してできる場所。",
    ritual: "この会のルールはひとつだけ。話は、ここに置いて帰る。",
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20sleek%20elegant%20shisha%20pipe%20as%20the%20main%20subject%20standing%20on%20a%20vivid%20cobalt%20blue%20table%2C%20bright%20minimalist%20lounge%20interior%20with%20white%20and%20light%20gray%20sofas%20softly%20blurred%20in%20the%20background%2C%20large%20windows%20with%20soft%20natural%20daylight%2C%20clean%20contemporary%20styling%2C%20the%20shisha%20pipe%20is%20polished%20and%20refined%20with%20delicate%20details%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20editorial%20product%20photography&width=1200&height=1500&seq=card-blue-02&orientation=portrait",
  },
  {
    id: "miyage",
    name: "土産話がある",
    french: "みやげ",
    tagline: "帰り道、誰かに話したくなる。",
    description:
      "この会では毎回、「今日持って帰れる話」をひとつ用意しています。テーマは、過去には「シーシャという文化」や「コーヒーのすすめ」など、仕事から少し離れた話。思わずへぇ、となり、社員や家族につい話してしまうような小さな土産話を持って帰れます。",
    features: ["毎回ひとつ持ち帰れる話", "仕事から少し離れたテーマ", "翌日誰かに話したくなる"],
    priceFrom: "体験入部 ¥9,500",
    provenance: "毎回テーマが変わる小さな知識の土産",
    lightStudy: "翌日、社員や家族につい話してしまう話。",
    ritual: "第一回「シーシャというものについて」第二回「コーヒーのすすめ」",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20minimalist%20lounge%20scene%20with%20a%20round%20cobalt%20blue%20table%20holding%20elegant%20coffee%20cups%20and%20glasses%20with%20drinks%2C%20white%20and%20light%20gray%20sofas%20with%20cushions%20in%20the%20background%2C%20soft%20natural%20daylight%20streaming%20through%20large%20windows%2C%20clean%20white%20walls%2C%20small%20blue%20accent%20chair%20visible%2C%20airy%20and%20stylish%20atmosphere%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20editorial%20interior%20photography&width=1200&height=1500&seq=card-blue-03&orientation=portrait",
  },
];

export interface ProcessStep {
  index: string;
  title: string;
  french: string;
  duration: string;
  description: string;
}

export const processSteps: ProcessStep[] = [
  {
    index: "01",
    title: "他己紹介",
    french: "Présentation",
    duration: "20:00〜",
    description:
      "自己紹介は、ありません。参加者のみなさんの紹介は、僕がやります。初対面の場で一番疲れるのは、自分で自分を説明して、少し盛ってしまうあの時間です。この会では、それをやらなくていい。紹介される側として、少し照れながら聞いていてください。",
  },
  {
    index: "02",
    title: "今日持って帰れる話",
    french: "La Connaissance",
    duration: "20:20〜",
    description:
      "会のはじめに、僕からひとつお話をします。テーマは毎回変わって、第一回は「シーシャというものについて」、第二回は「コーヒーのすすめ」。仕事とは関係ないけれど、帰ってから誰かに話したくなる、そんな話です。",
  },
  {
    index: "03",
    title: "最近のへぇ",
    french: "La Conversation",
    duration: "20:30〜",
    description:
      "話したいことがある方には、みなさんに向けて話してもらう時間があります。仕事の話でも、プライベートの話でも、普段どこにも話す場のなかった話でも。お願いはひとつだけ、聞いた人が「へぇ」とひとつ持ち帰れる話であることです。",
  },
  {
    index: "04",
    title: "自由時間",
    french: "Liberté",
    duration: "20:45〜",
    description:
      "あとはご自由に。会話や席替えは、僕が様子を見ながら回します。シーシャを吸わない方も、お酒を飲まない方も大丈夫です。紙巻きたばこも吸えますのでどうぞごゆるりと。話したい人と気の向くままに。",
  },
];

export interface CaseStudy {
  id: string;
  title: string;
  location: string;
  series: string;
  image: string;
  size: "wide" | "tall" | "square";
}

export const caseStudies: CaseStudy[] = [
  {
    id: "room-01",
    title: "今月の部室",
    location: "新宿",
    series: "シーシャラウンジ",
    size: "wide",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20view%20of%20a%20bright%20contemporary%20shisha%20lounge%20with%20multiple%20white%20and%20light%20gray%20sofa%20seating%20areas%20arranged%20in%20a%20spacious%20room%2C%20vivid%20cobalt%20blue%20accent%20tables%20and%20cushions%20throughout%2C%20large%20windows%20with%20abundant%20natural%20daylight%2C%20several%20elegant%20shisha%20pipes%20on%20low%20tables%2C%20clean%20minimalist%20white%20interior%20design%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20stylish%20editorial%20interior%20photography&width=1600&height=1100&seq=gallery-blue-01&orientation=landscape",
  },
  {
    id: "room-02",
    title: "ソファコーナー",
    location: "新宿",
    series: "くつろぎの空間",
    size: "tall",
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20cozy%20lounge%20sofa%20corner%20with%20plush%20light%20gray%20cushions%20and%20vivid%20cobalt%20blue%20throw%20pillows%2C%20a%20small%20blue%20side%20table%20with%20an%20elegant%20drink%20glass%2C%20soft%20natural%20daylight%20from%20a%20nearby%20window%2C%20white%20walls%20and%20clean%20minimalist%20interior%2C%20comfortable%20and%20inviting%20atmosphere%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20editorial%20interior%20photography%20with%20warm%20tones&width=1200&height=1500&seq=gallery-blue-02&orientation=portrait",
  },
  {
    id: "room-03",
    title: "ドリンクテーブル",
    location: "新宿",
    series: "おしゃれな一杯",
    size: "square",
    image:
      "https://readdy.ai/api/search-image?query=Top-down%20view%20of%20a%20cobalt%20blue%20round%20table%20in%20a%20bright%20minimalist%20lounge%2C%20elegant%20glasses%20with%20colorful%20drinks%20arranged%20neatly%2C%20a%20small%20shisha%20pipe%20hose%20coiled%20beside%20them%2C%20white%20marble%20floor%20pattern%20visible%20around%20the%20table%2C%20soft%20natural%20daylight%2C%20clean%20and%20stylish%20composition%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20editorial%20flat-lay%20photography&width=1200&height=1200&seq=gallery-blue-03&orientation=squarish",
  },
  {
    id: "room-04",
    title: "窓際の光",
    location: "新宿",
    series: "昼下がりの部室",
    size: "tall",
    image:
      "https://readdy.ai/api/search-image?query=Tall%20bright%20window%20in%20a%20minimalist%20lounge%20with%20soft%20white%20curtains%20partially%20drawn%2C%20vivid%20cobalt%20blue%20window%20frame%20and%20sill%2C%20an%20elegant%20shisha%20pipe%20sitting%20on%20the%20windowsill%20as%20a%20decorative%20element%2C%20light%20gray%20seating%20visible%20in%20the%20background%2C%20natural%20afternoon%20sunlight%20flooding%20the%20space%2C%20clean%20white%20walls%2C%20peaceful%20and%20airy%20atmosphere%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20editorial%20interior%20photography&width=1200&height=1500&seq=gallery-blue-04&orientation=portrait",
  },
  {
    id: "room-05",
    title: "みんなが集まる場所",
    location: "新宿",
    series: "放課後の空気",
    size: "wide",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20spacious%20lounge%20gathering%20area%20with%20multiple%20white%20and%20light%20gray%20modular%20sofas%20and%20sectionals%2C%20vivid%20cobalt%20blue%20accent%20chairs%20and%20coffee%20tables%20scattered%20throughout%2C%20large%20panoramic%20windows%20with%20bright%20daylight%2C%20elegant%20shisha%20pipes%20and%20drink%20glasses%20on%20tables%2C%20clean%20contemporary%20white%20interior%20with%20subtle%20blue%20details%2C%20welcoming%20stylish%20atmosphere%2C%20no%20smoke%2C%20no%20people%2C%20no%20faces%2C%20no%20text%2C%20editorial%20interior%20photography&width=1600&height=1100&seq=gallery-blue-05&orientation=landscape",
  },
];

export interface Testimonial {
  quote: string;
  name: string;
  role: string;
  city: string;
}

export const testimonials: Testimonial[] = [
  {
    quote:
      "大丈夫です。みなさんの紹介は僕がやりますし、会話も僕が回します。一人で来て、放っておかれることはありません。",
    name: "Q. 一人で参加しても大丈夫ですか？",
    role: "よくある質問",
    city: "01",
  },
  {
    quote:
      "吸っても吸わなくても大丈夫です。お酒も、飲んでも飲まなくても。初めての方には、僕が選び方からご案内します。",
    name: "Q. シーシャを吸ったことがないのですが。",
    role: "よくある質問",
    city: "02",
  },
  {
    quote:
      "この会では営業・勧誘はご遠慮いただいています。そういう場ではないので、安心して来てください。",
    name: "Q. 営業や勧誘をされませんか？",
    role: "よくある質問",
    city: "03",
  },
  {
    quote:
      "お振込みいただいた部費は、次に参加される回にそのまま充当します。無駄にはなりませんので、ご安心ください。",
    name: "Q. 申し込んだ後、行けなくなったら？",
    role: "よくある質問",
    city: "04",
  },
];

export const pressLogos: { name: string; tag: string }[] = [
  { name: "【○月○日(○)】", tag: "新宿 開催" },
  { name: "【○月○日(○)】", tag: "場所 未定" },
  { name: "月に一度", tag: "社長の放課後部" },
  { name: "体験入部", tag: "¥9,500" },
  { name: "新宿にて", tag: "シーシャラウンジ" },
  { name: "19:00〜", tag: "夜の部室" },
];

export const brandStats: { value: string; label: string; note: string }[] = [
  { value: "1", label: "ルールだけ", note: "ここで話したことは、外に持ち出さない。それだけです。" },
  { value: "月1", label: "回の開催", note: "月に一度、新宿のシーシャラウンジに集まります。" },
  { value: "10", label: "名前後の少人数制", note: "ゆっくり話せる規模を、ずっと守っています。" },
  { value: "19", label: "時スタート", note: "仕事終わりにそのまま来られる時間帯です。" },
];

export interface PhilosophyPillar {
  index: string;
  french: string;
  english: string;
  body: string;
  icon: string;
}

export const philosophyPillars: PhilosophyPillar[] = [
  {
    index: "I.",
    french: "繋がり",
    english: "Connection",
    body: "名刺の数を増やすことではなく、「この人になら大切な人を紹介できる」と思える相手と出会うこと。この会が約束したいのは、それだけです。",
    icon: "ri-heart-line",
  },
  {
    index: "II.",
    french: "話",
    english: "Talk",
    body: "経営者は日頃、聞き役に回ることが多いものです。普段は口にしないプライベートの話も、まだ誰にも言っていない考えも、ここでは話せます。",
    icon: "ri-chat-3-line",
  },
  {
    index: "III.",
    french: "土産",
    english: "Story",
    body: "毎回、今日持って帰れる話をひとつ用意しています。翌日、社員や家族につい話してしまうような小さな土産話です。",
    icon: "ri-gift-line",
  },
];

export interface BeyondCurtainItem {
  label: string;
  title: string;
  description: string;
  icon: string;
}

export const beyondCurtain: BeyondCurtainItem[] = [
  {
    label: "01 / 参加者",
    title: "経営者を中心に、集まっています",
    description:
      "参加者は経営者の方が中心です。どんな方をお招きするかは、毎回僕が考えています。誰が来ても、いい夜になるように。",
    icon: "ri-user-smile-line",
  },
  {
    label: "02 / 場所",
    title: "新宿のシーシャラウンジ",
    description:
      "今月の部室は、新宿のシーシャラウンジです。お申込みの方に詳しい場所をご案内します。シーシャを吸わない方も、お酒を飲まない方も大丈夫です。",
    icon: "ri-map-pin-line",
  },
  {
    label: "03 / 人数",
    title: "少人数制",
    description:
      "毎回、10人前後で開いています。その日集まった人の顔と話を、帰り道に全部思い出せる。それくらいの人数が、ちょうどいいと思っています。",
    icon: "ri-group-line",
  },
  {
    label: "04 / 部費",
    title: "体験入部 ¥9,500",
    description:
      "体験入部は9,500円。また、連続出席は8,500円、Bowers会員様は7,500円が部費となっております（シーシャ代・ドリンク2杯分込み、事前振込制）。お振込みで参加が確定します。行けなくなった場合は次回に充当します。",
    icon: "ri-ticket-line",
  },
];